/**
 * mapping.js controller
 */

import center from "@turf/center";
import { featureCollection } from "@turf/helpers";
import { updateGlobalState } from "../../../../src/slices/appSlice";
import {
  setMap,
  toggleTopPanelSection,
  setSidePanelOpen,
  setCurrentlyEditingThemeAndCollection,
  setWorkspace,
  setWorkspaces,
  setMapDirty,
  resetTruTerritoryState,
} from "../../../../src/slices/pagesSlice";
import { baseApi } from "../../../../src/slices/apiSlice";
import { store } from "../../../../src/store";

angular
  .module("routes:mapping")
  .controller(
    "truterritory",
    function (
      $rootScope,
      $scope,
      $geolocation,
      GoogleGeocoder,
      $state,
      workspaces,
      workspace,
      Collection,
      $window,
      $uibModal,
      $q,
      $timeout,
      Map,
      Storage,
      $location,
      INSTANCE_ID,
      MappingModals,
      ContextMenu,
      hasMapAccess,
      Theme,
      Restangular,
      API_ROOT,
      Session,
      Workspace
    ) {
      var originalMaps = {};

      store.dispatch(
        updateGlobalState({
          title: "TruTerritory",
          h1: "TruTerritory",
          activePage: "mapping",
          activeSection: "mapping",
        })
      );

      $scope.workspaces = workspaces;
      $scope.hasAccess = hasMapAccess;
      $scope.annotationsRefreshedAt = null;
      $scope.selectedFeatures = {};

      store.subscribe(() => {
        const { topPanelSections, isSidePanelOpen, isMapDirty, isSnippetToolOpen } = store.getState().pages.truterritory;

        setTimeout(() => {
          $scope.$apply(() => {
            $scope.topPanelSections = topPanelSections;

            $scope.isSidePanelOpen = isSidePanelOpen;
            $scope.isMapDirty = isMapDirty;
            $scope.isSnippetToolOpen = isSnippetToolOpen;
          });
        });
      });

      const { topPanelSections, isSidePanelOpen, isMapDirty, isSnippetToolOpen } = store.getState().pages.truterritory;

      $scope.topPanelSections = topPanelSections;

      $scope.isSidePanelOpen = isSidePanelOpen;
      $scope.isMapDirty = isMapDirty;
      $scope.isSnippetToolOpen = isSnippetToolOpen;

      $scope.workspace = workspace;
      $scope.mapDropModel = [];

      $scope.markerID = "";

      // If there are unsaved changes, don't let the user leave the page without confirmation
      $scope.$on("windowUnload", function (event, response) {
        if ($scope.isMapDirty && hasMapAccess("update")) {
          if (response.event.toState && response.event.toState.name.indexOf("mapping")) {
            response.message = "There are unsaved changes to this map. Are you sure you want to leave?";
          } else if (!response.event.toState) {
            response.message = "There are unsaved changes to this map";
          }
        }
      });

      $scope.$watch(
        "map",
        (map) => {
          store.dispatch(setMap(angular.copy(map)));
        },
        true
      );

      $scope.$watch(
        "workspace",
        (workspace) => {
          store.dispatch(setWorkspace(angular.copy(workspace)));
        },
        true
      );

      $scope.$watch(
        "workspaces",
        (workspaces) => {
          store.dispatch(setWorkspaces(JSON.parse(JSON.stringify(workspaces))));
        },
        true
      );

      $scope.$on("$destroy", function () {
        store.dispatch(resetTruTerritoryState());
      });

      $scope.setupMap = function (truMap) {
        $scope.truMap = truMap;
        loadEmptyMap(false);

        // If a collectionID was passed in via the URL, load it
        if ($state.params.collectionID) {
          let ID = $state.params.collectionID;

          // Remove collectionID from the URL without reloading the page
          $state.current.reloadOnSearch = false;
          $location.search("collectionID", undefined);
          $timeout(function () {
            $state.current.reloadOnSearch = undefined;
          });
          delete $state.params.collectionID;

          // Load the collection
          Collection.get(ID, { with: "themes,themes.rules" }).then($scope.addCollection);
        }

        // Or if we've recorded the previously viewed map, load that
        else if (Storage.getItem("mapID")) {
          let map = _.find(
            workspace.maps.flatMap((m) => [m, ...(m.children || m.views || [])]),
            { ID: Storage.getItem("mapID") }
          );
          if (map) $scope.addMap(map);
        }
      };

      /**
       * Open the left sidebar
       * @return {void}
       */
      $scope.openSidePanel = function () {
        store.dispatch(setSidePanelOpen(true));
      };

      /**
       * Close the left sidebar
       * @return {void}
       */
      $scope.closeSidePanel = function () {
        store.dispatch(setSidePanelOpen(false));
      };

      /**
       * Refresh the map based on current settings
       * @param  {Boolean} fireEvent
       * @return {void}
       */
      $scope.applyChanges = function (fireEvent = true, makeDirty = true) {
        $scope.map.createDateRangeIfEnabled();
        $scope.map.legends = $scope.map.getLegends();
        refreshTiles();

        // Only dirty the map if the user has permission to save it
        if (makeDirty && ($scope.map.allowCollaboration && hasMapAccess("collaborate") || hasMapAccess("update"))) makeMapDirty(fireEvent);
      };

      $scope.reload = $scope.applyChanges.bind(null, false, false);

      /**
       * Open the theme editor with the collection's current theme
       * TODO: move to <TruTerritorySide /> when those changes are merged
       * @param  {number} collectionID
       * @param  {number} themeID
       * @return {void}
       */
      $scope.onThemeEdit = function (collectionID) {
        const collection = $scope.map.collections.find((c) => c.ID === collectionID);
        const theme = collection.findTheme($scope.map, false);
        if (!collection || !theme) return;

        store.dispatch(
          setCurrentlyEditingThemeAndCollection({
            theme: Theme.dataOnly(theme),
            collection: { properties: collection.properties, aggregates: collection.aggregates },
          })
        );
        $scope.toggleTopPanel("theme");
      };

      /**
       * Apply a saved theme
       * @param  {Object} theme
       * @return {void}
       */
      $scope.onThemeSave = function (theme) {
        let collection = _.find($scope.map.collections, { ID: theme.collectionID }),
          index = _.findIndex(collection.themes, { ID: theme.ID }),
          oldTheme = collection.themes[index],
          labelChanged = oldTheme && oldTheme.label != theme.label;

        // Replace the original theme with the edited copy
        if (index == -1) {
          // remove the default theme if it's been added
          if (collection.themes[0]?.ID === undefined) {
            collection.themes.splice(0, 1);
          }
          collection.themes.push(theme);
        } else collection.themes[index] = theme;

        // Apply this theme to its collection.
        // Use the theme's label only if it has changed.
        setTheme(collection, theme, labelChanged);
        $scope.$broadcast("themeUpdated");
        store.dispatch(setCurrentlyEditingThemeAndCollection({ theme, collection }));
      };

      /**
       * Cleanup after a theme deletion
       * @param  {Object} theme
       * @return {void}
       */
      $scope.onThemeDelete = function (theme) {
        store.dispatch(baseApi.endpoints.deleteTheme.initiate(theme)).then(() => {
          let collection = _.find($scope.map.collections, { ID: theme.collectionID }),
            index = _.findIndex(collection.themes, { ID: theme.ID });

          // Remove the theme from the themes array & from the map
          collection.themes.splice(index, 1);
          delete $scope.map.themes[collection.ID];

          setTheme(collection, collection.findTheme($scope.map));
          $scope.$broadcast("themeDeleted");
          store.dispatch(toggleTopPanelSection("theme"));
          store.dispatch(setCurrentlyEditingThemeAndCollection({ theme: null, collection: null }));
        });
      };

      /**
       * Geocodes a text string and sets the view based on the return lat/long
       * @param  {string} text
       * @return {void}
       */
      $scope.mapSearch = function (text) {
        GoogleGeocoder.getLatLong(text).then(function (latlng) {
          let makeMenu = ContextMenu.make.bind(null, findCollection, false, text);
          $scope.truMap.removeLayer($scope.markerID);
          $scope.markerID = $scope.truMap.addMarker([latlng.lat, latlng.lng], makeMenu);
          $scope.truMap.setView([latlng.lat, latlng.lng], 14, { animate: true });
        });
      };

      /**
       * Add the given collection to the map
       * @param  {object} collection the collection to be added
       * @return {Promise}
       */
      $scope.addCollection = function (collection) {
        collection = angular.copy(collection);
        collection.themes = (collection.themes && collection.themes.filter((t) => t.workspaceID === $scope.map.workspaceID)) || [];

        // Add collection to workspace
        // Not precisely correct, because it's actually part of the workspace until the map is saved,
        // but this works for now.
        if (!_.find($scope.workspace.collections, { ID: collection.ID })) $scope.workspace.collections.push(collection);

        // Add the collection to the map and set necessary data
        $scope.map.collections.push(collection);
        $scope.map.collectionIDs.push(collection.ID);
        $scope.map.visible[collection.ID] = true;
        let theme = collection.findTheme($scope.map);
        $scope.map.themes[collection.ID] = theme.ID;
        $scope.map.labels[collection.ID] = theme.label;
        $scope.$broadcast("collectionAdded");

        $scope.applyChanges();
      };

      /**
       * If a map has been dropped on the canvas
       * @param  {object} map the added map
       * @param  {boolean} [saveOriginal=true] Whether to save a copy of the original map or not
       * @return {Promise}
       */
      $scope.addMap = function (map, saveOriginal = true, checkDirtyState = true) {
        // Restangularizing the element because it may be coming from React.
        if (!("setup" in map)) {
          map = Restangular.restangularizeElement(null, angular.copy(map), "mapping/maps");
        }

        // Make sure an unsaved map isn't overwritten by a new one
        if (checkDirtyState && $scope.isMapDirty) {
          return (
            MappingModals.openSaveMapChanges("Do you want to save before loading a new map?", $scope.saveMap.bind(null, $scope.map), "Save", "Don't Save")
              // If the user wants to save changes, do it.
              .then(function () {
                return $scope.saveMap($scope.map);
              })
              // If the user said no to saving changes, ignore changes.
              .catch(function () {
                store.dispatch(setMapDirty(false));
                // this has to be forcibly set on scope b/c it's not set right away by the redux dispatch
                $scope.isMapDirty = false;
              })
              // Whatever they said, load the new map.
              .finally(function () {
                return $scope.addMap(map, saveOriginal);
              })
          );
        }

        map.setup($scope.workspace.collections);
        Storage.setItem("mapID", map.ID);

        if (saveOriginal) setOriginalMap(map);

        // Clear the map and set the canvas to clean
        $scope.truMap.clear([$scope.markerID]);
        $scope.selectedFeatures = {};
        store.dispatch(setMapDirty(false));
        $scope.drawingEnabled = false;
        $scope.annotationsRefreshedAt = null;
        return refreshTiles(map).then(function () {
          $scope.map = map;
          $scope.$broadcast("newMapCreated", map);
        });
      };

      $scope.loadMapBookmark = function (map) {
        var promise;

        if (map.workspaceID != $scope.workspace.ID) {
          var workspace = _.find($scope.workspaces, { ID: map.workspaceID });
          promise = $scope.setWorkspace(workspace);
        } else promise = $q.when();

        promise.then($scope.addMap.bind(null, map, false, true));

        return promise;
      };

      /**
       * Get the original map by map ID
       * @param  {integer} mapID
       * @return {object}
       */
      $scope.getOriginalMap = function (mapID) {
        return originalMaps[mapID];
      };

      // Just to expose this to the public controller
      $scope.setOriginalMap = setOriginalMap;

      /**
       * Creates a new map
       * @return {void}
       */
      $scope.createNewMap = function (saveMarker = false) {
        // Create a new empty map
        loadEmptyMap(true, saveMarker);

        // Broadcast the changes
        $scope.$broadcast("newMapCreated", $scope.map);
      };

      /**
       * Toggles the layers panel
       * @return {void}
       */
      $scope.toggleTopPanel = function (activeSection) {
        store.dispatch(toggleTopPanelSection(activeSection));
      };

      /**
       * Centers the canvas on the user's current location
       * @return {void}
       */
      $scope.centerOnCurrentLocation = function () {
        $scope.locationActive = true;
        $geolocation
          .getCurrentPosition({
            timeout: 60000,
          })
          .then(function (position) {
            let makeMenu = ContextMenu.make.bind(null, findCollection, false, "");
            $scope.truMap.removeLayer($scope.markerID);
            $scope.markerID = $scope.truMap.addMarker([position.coords.latitude, position.coords.longitude], makeMenu);
            $scope.truMap.setView([position.coords.latitude, position.coords.longitude], 15, { animate: true });
          })
          .finally(function () {
            $scope.locationActive = false;
          });
      };

      /**
       * Makes a request to save the map if there is an ID, otherwise it saves a new map
       * @param  {object} map
       * @return {object} promise
       */
      $scope.saveMap = function (map, refresh = false) {
        return map.ID && (hasMapAccess("update") || (hasMapAccess("collaborate") && map.allowCollaboration))
          ? $scope.updateMap(map, refresh)
          : MappingModals.openSaveMap({ ...map, ID: undefined }, $scope.createMap, workspace.getTopLevelMaps());
      };

      $scope.updateMap = function (map, refresh = false) {
        return store
          .dispatch(baseApi.endpoints.updateMap.initiate(angular.copy({ ...Map.dataOnly(map), collections: undefined })))
          .then(function () {
            $scope.$apply(function () {
              $scope.workspace.maps[_.findIndex($scope.workspace.maps, { ID: map.ID })] = map;
              $scope.map = map;
              map.setup($scope.workspace.collections);
              store.dispatch(setMapDirty(false));
              setOriginalMap(map);
            });
          })
          .then(function () {
            if (refresh) {
              $scope.applyChanges();
            }
          });
      };

      $scope.createMap = function (map) {
        return store.dispatch(baseApi.endpoints.createMap.initiate(map)).then(function ({ data: newMap }) {
          map.ID = newMap.ID;
          map.UUID = newMap.UUID;
          Map.restangularize(map);
          map.setup($scope.workspace.collections);

          // Add map to parent's view (temporary) or to complete list of maps
          if (map.parentID) {
            // The two copies of the workspace are used by different things and aren't in sync.
            addMapToParent(map, $scope.workspace);
            addMapToParent(map, _.find($scope.workspaces, { ID: $scope.workspace.ID }));
          } else {
            $scope.workspace.maps.push(map);
            _.find($scope.workspaces, { ID: $scope.workspace.ID }).maps.push(map);
          }

          $scope.map = map;
          $scope.truMap.clearSelection(Object.keys($scope.selectedFeatures));
          $scope.selectedFeatures = {};
          store.dispatch(setMapDirty(false));

          Storage.setItem("mapID", map.ID);

          // If any layers are selectable, they must have just been set so. Reload the map so that the vector tiles get fetched.
          if (Object.keys(map.selectable).find((k) => map.selectable[k])) {
            $scope.applyChanges();
          }
        });
      };

      /**
       * Sets the current workspace
       * @param {object} workspace
       * @param {Promise}
       */
      $scope.setWorkspace = async function (workspace, fetch = true) {
        if ($scope.isMapDirty) {
          try {
            await MappingModals.openSaveMapChanges("Would you like to save changes before switching workspaces?", $scope.saveMap.bind(null, $scope.map), "Save", "Don't Save");
          } catch (e) {
            // A rejection means "no, I don't want to save."
            store.dispatch(setMapDirty(false));
          }
        }

        if (!fetch) return $q.when(set(workspace));
        else return $scope.workspaces.getWorkspace(workspace.ID).then(set);

        function set(workspace) {
          $scope.workspace = workspace;
          $scope.createNewMap(true);
          Storage.setItem("workspace", workspace.ID);
          return workspace;
        }
      };

      $scope.createWorkspaceClone = function (workspace) {
        return workspace.postClone().then(addWorkspace);
      };

      /**
       * Deletes a map
       * @param  {object} map
       * @return {void}
       */
      $scope.deleteMap = function (map) {
        store.dispatch(baseApi.endpoints.deleteMap.initiate(map)).then(function () {
          if (map.ID == $scope.map.ID) loadEmptyMap(true, true);
          $scope.workspace.maps.splice(_.findIndex($scope.workspace.maps, { ID: map.ID }), 1);
          _.find($scope.workspaces, { ID: $scope.workspace.ID }).maps.splice(_.findIndex($scope.workspace.maps, { ID: map.ID }), 1);
        });
      };

      $scope.timeframeChanged = function (range) {
        $scope.map.dateRange = range;
        refreshTiles();
        $scope.$broadcast("timeframeChanged");
      };

      $scope.toggleDrawing = function () {
        let map = !$scope.map.parentID ? $scope.map : $scope.workspace.maps.find((m) => m.ID == $scope.map.parentID);
        $scope.drawingEnabled = !$scope.drawingEnabled;
        if ($scope.drawingEnabled) {
          $scope.truMap.enableDrawing(onCreate, onEdit, onDelete, onRefresh);
          map.getAnnotations($scope.annotationsRefreshedAt).then(setDrawn);
        } else {
          $scope.truMap.disableDrawing();
        }

        // Wrap the callbacks so that they always draw the new current layer.
        function onCreate(feature) {
          map.addAnnotation(feature, $scope.annotationsRefreshedAt).then(setDrawn);
        }
        function onEdit(features) {
          map.editAnnotations(features, $scope.annotationsRefreshedAt).then(setDrawn);
        }
        function onDelete(ids) {
          map.deleteAnnotations(ids, $scope.annotationsRefreshedAt).then(setDrawn);
        }
        function onRefresh() {
          map.getAnnotations($scope.annotationsRefreshedAt).then(setDrawn);
        }
        function setDrawn(response) {
          $scope.truMap.setDrawnItems(response.updated);
          $scope.truMap.removeDrawnItems(response.deleted);
          $scope.annotationsRefreshedAt = moment(response.timestamp);
        }
      };

      function findCollection(id) {
        return $scope.map.collections.find((c) => c.ID == id);
      }

      /**
       * Add a new map to its parent in the given workspace.
       */
      function addMapToParent(map, workspace) {
        let parent = workspace.maps.find((m) => m.ID == map.parentID);

        if (parent.views) {
          parent.views.push(map);
        } else {
          parent.views = [map];
        }
      }

      /**
       * Removes a collection from the map
       * @param  {number} ID collection id
       * @return {void}
       */
      $scope.removeCollection = function (ID) {
        $scope.map.collections = $scope.map.collections.filter((c) => c.ID !== ID);
        $scope.map.collectionIDs = $scope.map.collectionIDs.filter((c) => c !== ID);

        delete $scope.map.visible[ID];
        delete $scope.map.filters[ID];
        delete $scope.map.themes[ID];

        $scope.applyChanges();

        $scope.map.legends = $scope.map.getLegends();
      };

      //#region right side

      $scope.toggleVisible = function (ID) {
        $scope.map.visible[ID] = !$scope.map.visible[ID];
        $scope.applyChanges();
      };

      $scope.setMapLabel = function (ID, label) {
        $scope.map.labels[ID] = label;
        $scope.applyChanges();
      };

      $scope.setMapTheme = function (ID, theme) {
        $scope.map.themes[ID] = theme.ID;
        $scope.map.labels[ID] = theme.label;

        $scope.applyChanges();
      };

      $scope.addTheme = function (collectionID) {
        const collection = $scope.map.collections.find((c) => c.ID === collectionID);
        const theme = Theme.getDefaultTheme(collection, $scope.map.workspaceID);
        store.dispatch(baseApi.endpoints.createTheme.initiate(theme)).then(({ data: newTheme }) => postCreateTheme(collection, newTheme));
      };

      /**
       * Clones a theme
       * @param  {number} collectionID
       * @param  {object} toClone    the theme to clone
       * @return {void}
       */
      $scope.cloneTheme = function (collectionID, toClone) {
        const collection = $scope.map.collections.find((c) => c.ID === collectionID);
        $uibModal
          .open({
            templateUrl: "/truterritory/clone-theme.html",
            controller: function ($scope) {
              $scope.theme = Theme.dataOnly(toClone);
            },
          })
          .result.then(function (theme) {
            store.dispatch(baseApi.endpoints.createTheme.initiate(theme)).then(({ data: newTheme }) => postCreateTheme(collection, newTheme));
          });
      };

      /**
       * The closure that's fired after creating/cloning a theme
       *   Adds the theme to the collection array
       *   Sets the theme
       * @param  {object} collection
       * @param  {object} theme
       * @return {void}
       */
      function postCreateTheme(collection, theme) {
        // Create the themes array if it doesn't exist
        if (!collection.themes) collection.themes = [];

        // Add the theme to the collections array
        collection.themes.push(theme);
        $scope.setMapTheme(collection.ID, theme);
      }

      $scope.setFilters = function (ID, filters) {
        $scope.map.filters[ID] = filters;
        $scope.applyChanges();
      };

      $scope.setCollections = function (collections) {
        $scope.map.collections = collections;
        $scope.map.collectionIDs = collections.map((c) => c.ID);
        $scope.applyChanges();
      };

      $scope.selectionActions = {
        // clear undoes all selections and restore feature states.
        clear: () => {
          $scope.truMap.clearSelection(Object.keys($scope.selectedFeatures));
          $scope.$apply(() => ($scope.selectedFeatures = {}));
        },

        // goTo zooms/pans as needed to fit the selection in the map view.
        goTo: () => {
          // Make a flat list of features.
          const features = [];
          for (const layerName in $scope.selectedFeatures) {
            for (const featureId in $scope.selectedFeatures[layerName]) {
              features.push($scope.selectedFeatures[layerName][featureId]);
            }
          }

          $scope.truMap.goTo(features);
        },

        // filterBy converts the selection into collection-level filters and applies them to the map.
        filterBy: () => {
          if (!$scope.selectedFeatures) {
            return;
          }

          // For each layer in the selection, filter down to matching feature IDs.
          $scope.$apply(() => {
            for (layerName in $scope.selectedFeatures) {
              const collection = $scope.map.collections.find((c) => c.tableName == layerName);
              const filter = { operator: "IN", column: collection.idColName, value: Object.keys($scope.selectedFeatures[layerName]) };

              // To make this work predictably, we have to first remove any "IN" filter(s) on idColName.
              const baseFilters = ($scope.map.filters[collection.ID] || []).filter((f) => !(f.operator == "IN" && f.column == collection.idColName));

              // We add to existing filters for this collection (implicit AND), if present.
              $scope.map.filters[collection.ID] = [...baseFilters, filter];
            }

            $scope.applyChanges();
          });

          // For layers not in the selection, don't do anything??
        },

        combine: () => {
          console.log("combining...");
        },

        // downloadReport will download a report PDF in a separate tab.
        downloadReport: async (filter = false) => {
          if (!$scope.selectedFeatures) {
            return;
          }

          // Choose the first report (parent preferred) which accepts selection.
          const map = $scope.map.parentID ? $scope.workspace.maps.find((m) => m.ID == $scope.map.parentID) : $scope.map;
          const report = map.reports && map.reports.find((r) => r.acceptsSelection);
          if (!report) {
            return;
          }

          // Make the set of selected IDs and a bounding box containing them all.
          let selection = {};
          let features = [];
          for (const layerId in $scope.selectedFeatures) {
            selection[layerId] = Object.keys($scope.selectedFeatures[layerId]);
            features.push(...selection[layerId].map((k) => $scope.selectedFeatures[layerId][k].toJSON()));
          }

          const point = center(featureCollection(features)).geometry.coordinates;
          const preflight = $scope.map.getPreflightMap();

          // Set filters.
          if (filter) {
            for (layerName in $scope.selectedFeatures) {
              const collection = $scope.map.collections.find((c) => c.tableName == layerName);
              const filter = { operator: "IN", column: collection.idColName, value: Object.keys($scope.selectedFeatures[layerName]) };

              // To make this work predictably, we have to first remove any "IN" filter(s) on idColName.
              let preflightCollection = preflight.collections.find((c) => c.ID == collection.ID);
              const baseFilters = (preflightCollection.filters[collection.ID] || []).filter((f) => !(f.operator == "IN" && f.column == collection.idColName));

              // We add to existing filters for this collection (implicit AND), if present.
              preflightCollection.filters = [...baseFilters, filter];
            }
          }

          try {
            // Download the bytestream and load it into a Blob.
            const resp = await fetch(`${API_ROOT}/mapping/reports/${report.ID}/${INSTANCE_ID}/${point[1]}/${point[0]}?entityID=${$scope.map.entityID}`, {
              method: "POST",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ selection, map: preflight }),
            });

            if (resp.status != 200) {
              const data = await resp.json();
              if (data.status && data.status.message) {
                return data.status.message;
              }

              return resp.statusText;
            }

            // Create an object URL for the blob, make an anchor element pointing to it, and "click" on the element.
            const url = URL.createObjectURL(await resp.blob());
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.pdf";

            // Clean up on click
            const cleanup = () => {
              setTimeout(() => {
                URL.revokeObjectURL(url);
                removeEventListener("click", cleanup);
              }, 200);
            };

            a.addEventListener("click", cleanup, false);
            a.click();

            return "";
          } catch (error) {
            console.log("returning error", error);
            return error.toString();
          }
        },

        canDownloadReport: () => {
          let map = !$scope.map.parentID ? $scope.map : $scope.workspace.maps.find((m) => m.ID == $scope.map.parentID);
          return !!(map.reports && map.reports.find((r) => r.acceptsSelection));
        },
      };

      //#endregion

      //#region layers

      /**
       * Remove a collection from the current workspace
       * @param  {int} collectionID
       * @return {void}
       */
      $scope.removeCollectionFromWorkspace = function (collectionID) {
        $scope.workspace.removeCollection(collectionID);
      };

      /**
       * Update the name or sharing options of the workspace
       * @param  {object} partialWorkspace The workspace object with only the fields to be updated, only name and sharingEnabled are supported
       */
      $scope.updateWorkspace = function (partialWorkspace) {
        $scope.workspace.patch(_.pick(partialWorkspace, ["name", "sharingEnabled"]));
        $timeout(() => {
          $scope.workspace.name = partialWorkspace.name;
          $scope.workspace.sharingEnabled = partialWorkspace.sharingEnabled;
        });
      };

      /**
       * Remove the logged-in user from the given workspace
       * @param  {Object} workspace
       * @return {Promise}
       */
      $scope.removeWorkspace = function (workspace) {
        let userID = Session.get("ID");

        let modal = $uibModal.open({
          templateUrl: "/truterritory/confirm-remove-user-workspace.html",
        });

        return modal.result
          .then(function () {
            // workspace might be coming from redux and needs to be restangularized
            const remove = "removeUser" in workspace ? workspace.removeUser : Restangular.restangularizeElement(null, angular.copy(workspace), "mapping/workspaces").removeUser;
            return remove(userID);
          })
          .then(function () {
            const index = $scope.workspaces.findIndex((w) => w.ID === workspace.ID);
            $scope.workspaces.splice(index, 1);
            if (workspace.ID == $scope.workspace.ID) {
              // look, your guess is as good as mine.
              //  Why doesn't Array.prototype.find work here? No clue. Why didn't lodash _.find work? No clue.
              //  Why does this work? No clue. But it does, so just move on. Nothing to see here *waves hands* this isn't the code smell you're looking for
              const defaultWorkpace = Array.from($scope.workspaces).find((w) => w.default);
              if (defaultWorkpace) $scope.setWorkspace(defaultWorkpace);
            }
          });
      };

      /**
       * Create a new workspace
       * @param  {Object} workspace
       * @return {Promise}
       */
      $scope.createWorkspace = function (workspace) {
        let userID = Session.get("ID");
        workspace = { name: workspace.name, userID: userID, userIDs: [userID] };
        return Workspace.post(workspace, { with: "all" }).then(function (response) {
          $scope.workspaces = $scope.workspaces.concat([response]);
          return $scope.setWorkspace(response, false);
        });
      };

      $scope.saveUsers = function (users) {
        return $scope.workspace.saveUsers(users).then(() => {
          $scope.workspace.users = users;
        });
      };

      /**
       * Remove a user from the current workspace
       * @param  {int} userID
       * @return {void}
       */
      $scope.removeUser = function (userID) {
        $scope.workspace.removeUser(userID).then(() => {
          $scope.workspace.users = $scope.workspace.users.filter((u) => u.ID !== userID);
        });
      };

      $scope.addCollectionForLayers = function (data) {
        if (!_.find($scope.map.collections, { ID: data.ID })) {
          if (!("findTheme" in data)) {
            data = Restangular.restangularizeElement(null, angular.copy(data), "mapping/collections");
          }

          let collection = _.find($scope.workspace.collections, { ID: data.ID }) || data;
          $scope.addCollection(collection);
        }
      };

      $scope.addMapById = function (mapID) {
        let map = _.find($scope.workspace.maps, { ID: mapID });
        $scope.addMap(map);
      };

      //#endregion

      /**
       * Loads an empty map
       * @param {bool} forget If true, forget the previous map
       * @return {void}
       */
      function loadEmptyMap(forget = true, saveMarker = false) {
        $scope.map = Map.getEmptyMap($scope.workspace.ID, $state.params.entityID);
        store.dispatch(setMapDirty(false));
        $scope.truMap.clear(saveMarker ? [$scope.markerID] : []);
        $scope.selectedFeatures = {};
        if ($scope.drawingEnabled) $scope.toggleDrawing();

        if (forget) Storage.removeItem("mapID");
      }

      /**
       * Clones the passed-in map, and sets it on the originalMaps object
       * @param {object} map
       */
      function setOriginalMap(map) {
        originalMaps[map.ID] = map.clone();
      }

      function addWorkspace(workspace) {
        $scope.workspaces.push(workspace);
        $scope.workspace = workspace;
        $scope.createNewMap();
        Storage.setItem("workspace", workspace.ID);
      }

      function refreshTiles(map) {
        map = map || $scope.map;
        return map
          .sendRenderingPreflight()
          .then(function (data) {
            let tileLayer = $scope.truMap.addOrUpdateTruTileLayer(INSTANCE_ID);
            tileLayer.on("loading", function (e) {
              $scope.$apply(function () {
                $scope.tilesLoading = true;
              });
            });
            tileLayer.on("load", function (e) {
              $scope.$apply(function () {
                $scope.tilesLoading = false;
              });
            });

            try {
              const layers = map.collections.filter((c) => map.selectable[c.ID] && map.visible[c.ID] && !!c.idColName);
              const layerNames = layers.map((c) => c.tableName);
              const layerIds = layers.reduce((agg, c) => ({ ...agg, [c.tableName]: c.idColName }), {});
              if (hasMapAccess("collaborate")) {
                $scope.truMap.addOrUpdateTruVectorLayer(INSTANCE_ID, layerNames, layerIds, featuresSelected, featuresDeselected);
              }
            } catch (e) {
              console.log("Failed initializing vector layer", e);
            }

            map.aggregates = data.aggregates;
          })
          .catch(function (fallback) {
            // Generate our functional error code / message
            let errorCode = ((fallback.data && fallback.data.status && fallback.data.status.code) || fallback.status) + "";
            let errorMessage = (fallback.data && fallback.data.status && fallback.data.status.message) || fallback.statusText;

            // Only popup a message if we have something meaningful to say
            if (errorCode !== "-1" && errorCode !== "403" && (errorCode || errorMessage)) {
              $rootScope.$broadcast("httpError", {
                error: {
                  status: {
                    exception: "generic",
                    code: errorCode,
                    message: "Error during map preflight: " + (errorMessage || "unknown error"),
                  },
                },
              });
            }

            return [];
          });
      }

      function featuresSelected(features) {
        $scope.$apply(() => {
          for (feature of features) {
            if (!(feature.sourceLayer in $scope.selectedFeatures)) {
              $scope.selectedFeatures[feature.sourceLayer] = {};
            }

            $scope.selectedFeatures[feature.sourceLayer][feature.id] = feature;
          }

          $scope.selectedFeatures = { ...$scope.selectedFeatures }; // Copy to trigger re-render in React.
        });
      }

      function featuresDeselected(features) {
        $scope.$apply(() => {
          let deleted = 0;
          for (feature of features) {
            if (feature.sourceLayer in $scope.selectedFeatures && feature.id in $scope.selectedFeatures[feature.sourceLayer]) {
              delete $scope.selectedFeatures[feature.sourceLayer][feature.id];
              deleted++;

              if (Object.keys($scope.selectedFeatures[feature.sourceLayer]).length == 0) {
                delete $scope.selectedFeatures[feature.sourceLayer];
              }
            }
          }

          if (deleted > 0) {
            $scope.selectedFeatures = { ...$scope.selectedFeatures }; // Copy to trigger re-render in React.
          }
        });
      }

      function makeMapDirty(fireEvent = true) {
        if (fireEvent) $scope.$broadcast("mapDirtied");
        store.dispatch(setMapDirty(true));
      }

      /**
       * Set the theme for a given collection
       * @param {Object}  collection
       * @param {Object}  theme
       * @param {Boolean} useThemeLabel Whether to override the map's label setting with the theme's
       */
      function setTheme(collection, theme, useThemeLabel = true) {
        $scope.map.themes[collection.ID] = theme.ID;
        if (useThemeLabel) $scope.map.labels[collection.ID] = theme.label;

        $scope.applyChanges();
      }
    }
  );
